import React, { useEffect, useState, useRef } from 'react';
export function Section({
  children,
  className = '',
  id,
  variant = 'default'
}: {
  children: React.ReactNode;
  className?: string;
  id?: string;
  variant?: 'default' | 'alt' | 'upsell';
}) {
  const ref = useRef<HTMLElement>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        observer.unobserve(el);
      }
    }, {
      rootMargin: '-80px'
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
  let bgClass = '';
  if (variant === 'alt') bgClass = 'bg-brand-bgAlt';
  if (variant === 'upsell') bgClass = 'bg-brand-upsell text-white';
  return <section id={id} className={`${bgClass} transition-all duration-600`} style={{
    contentVisibility: 'auto',
    containIntrinsicSize: 'auto 500px'
  } as React.CSSProperties} data-id="element-246">
      <div ref={ref} className={`py-16 md:py-24 px-4 ${variant === 'upsell' ? 'max-w-5xl' : 'max-w-4xl'} mx-auto transition-all duration-600 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-5'} ${className}`} style={{
      transitionDuration: '600ms'
    }} data-id="element-247">
        {children}
      </div>
    </section>;
}